module.exports = __webpack_public_path__ + "img/Console_White.a4a6cabf.svg";